import { Grid } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { ruleManagementApis } from 'api'
import { NA } from 'constans/common'
import { RULE_MANAGEMENT_DETAILS } from 'constans/queryKeys'
import { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Container } from 'shared/components'
import DateTimeCell from 'shared/components/DateTimeCell'
import ItemDetails from 'shared/components/ItemDetails'
import * as urls from 'constans/urls'
import { formatNumber } from 'utils/formatNumber'

const RuleManagementDetails = () => {
  const { ruleId } = useParams()
  const navigate = useNavigate()
  const { data } = useQuery({
    queryKey: [RULE_MANAGEMENT_DETAILS, ruleId],
    queryFn: () => ruleManagementApis.get(ruleId || ''),
    enabled: !!ruleId,
  })

  const details = useMemo(() => {
    if (data && data.Result && data.Result) {
      return data.Result[0]
    }
    return undefined
  }, [data])

  const goToEdit = () => {
    navigate(
      `/${urls.RULE_MANAGEMENT_URLS.EDIT.replace(
        ':ruleId',
        `${details?.RuleId}` || ''
      )}`
    )
  }

  const goBack = () => {
    navigate(`/${urls.RULE_MANAGEMENT_URLS.LIST}`)
  }

  return (
    <Container title="Chi tiết quy tắc">
      <Grid
        container
        sx={() => ({
          gap: 2,
          '& > div': {
            boxShadow: 1,
            p: 2,
            borderRadius: 2,
            '& > div': {
              height: '100%',
            },
          },
        })}
      >
        <Grid item xs>
          <Grid direction="column" gap={1} container>
            <ItemDetails title="Tên quy tắc" value={details?.RuleName || NA} />
            <ItemDetails
              title="Số lượng tem"
              value={details?.TemQuantity || NA}
            />
            <ItemDetails
              title="Giá trị hóa đơn từ"
              value={`${formatNumber(details?.TotalBill || 0)}đ` || NA}
            />
            <ItemDetails
              title="Giá trị hóa đơn đến"
              value={`${formatNumber(details?.TotalBillTo || 0)}đ` || NA}
            />
          </Grid>
        </Grid>
        <Grid item xs>
          <Grid direction="column" gap={1} container>
            {/* <ItemDetails
              title="Ngày bắt đầu quà tặng"
              value={<DateTimeCell value={details?.GiftStartTime} />}
            />
            <ItemDetails
              title="Ngày kết thúc quà tặng"
              value={<DateTimeCell value={details?.GiftEndTime} />}
            /> */}
            <ItemDetails
              title="Ngày bắt đầu tem"
              value={<DateTimeCell value={details?.TemStartTime} />}
            />
            <ItemDetails
              title="Ngày bắt kết thúc tem"
              value={<DateTimeCell value={details?.TemEndTime} />}
            />
          </Grid>
        </Grid>

        <Grid item xs>
          <Grid direction="column" gap={1} container>
            <ItemDetails title="Người tạo" value={details?.CreatedUser || NA} />
            <ItemDetails
              title="Ngày tạo"
              value={<DateTimeCell value={details?.CreatedDate} />}
            />

            <ItemDetails
              title="Người cập nhật"
              value={details?.UpdatedUser || NA}
            />
            <ItemDetails
              title="Ngày cập nhật"
              value={<DateTimeCell value={details?.UpdatedDate} />}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container mt={2} gap={2}>
        <Button onClick={goBack} color="inherit">
          Quay về
        </Button>
        <Button onClick={goToEdit} color="warning">
          Cập nhật
        </Button>
      </Grid>
    </Container>
  )
}

export default RuleManagementDetails
